import { validateVisualPropJSON } from '../../../utils/form-builder.util';
export const validateVisualPropsEventPayloadObject = (updatedProps, visualPropEditorDefinition) => {
    const errors = validateVisualPropJSON(updatedProps, visualPropEditorDefinition?.elements ?? []);
    if (errors.length > 0) {
        throw new Error(errors.join('\n'));
    }
};
//# sourceMappingURL=util.js.map